module.exports = __webpack_public_path__ + "media/stylesheets/images/mypage/rectangle_thumb-1988b57eb15b1841d8b424d35c7e8498.png";